<template>
  <div>
    <van-popup
      v-model="childShow"
      position="right"
      :style="{ height: '100%', width: '100%', background: '#f5f5f5' }"
    >
      <div class="child">
        <van-nav-bar :style="{ 'background-color': '#f9f9f9' }">
          <van-icon size="20" slot="left" @click="close" name="arrow-left" color="#333" />
          <div slot="title">切换子女</div>
        </van-nav-bar>
        <div>
          <div
            v-for="(item, index) in childList"
            :key="item.ChildrenID"
            @click="changeChild(item, index)"
            class="letter-list van-hairline--bottom"
          >
            <div class="flex">
              <img v-if="item.Icon" class="child-img" :src="api + item.Icon" alt />
              <div v-else class="child-icon-default">{{ item.IconFullName }}</div>
              <div class="child-content">
                <div class="child-name">{{ item.FullNameStudent }}</div>
                <div class="child-class">
                  {{ item.StudentYearName }}{{ item.StudentGradeName
                  }}{{ item.StudentOrganizationName }}
                </div>
                <div class="child-school">{{ item.SchoolDistrictName }}</div>
              </div>
            </div>
            <div>
              <van-icon
                name="success"
                size="20px"
                :color="index === isIndex ? '#4196ff' : '#fff'"
              />
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "child",
  props: {
    childShow: Boolean
  },
  data() {
    return {
      isIndex: 0,
      childList: [],
      child: {},
      api: "",
      isChild: true,
      reg: /^[A-Za-z0-9]+$/,
      regNumber: /\d+/
    };
  },
  watch: {
    childList: {
      handler(newVal) {
        for (let i = 0, len = newVal.length; i < len; i++) {
          if (this.$store.state.parentInfo.childData.ChildrenID === newVal[i].ChildrenID) {
            this.isIndex = i;
          }
        }
      },
      deep: true
    }
  },
  created() {
    this.api = this.xyMApi;
  },
  mounted() {
    this.childList = this.$store.state.parentInfo.allChildList;
    this.childList.map(item => {
      if (this.reg.test(item.FullNameStudent) || this.regNumber.test(item.FullNameStudent)) {
        item["IconFullName"] = item.FullNameStudent.substring(0, 2);
      } else {
        if (item.FullName.length > 2) {
          item["IconFullName"] = item.FullNameStudent.substring(item.FullNameStudent.length - 1, 3);
        } else {
          item["IconFullName"] = item.FullNameStudent.substring(0, 2);
        }
      }
    });
  },
  methods: {
    close() {
      this.$emit("listenToChildClose", false);
    },
    changeChild(val, i) {
      this.isIndex = i;
      this.$store.commit("parentInfo/addChildData", val); //当前孩子信息
      this.$emit("listenToChildClose", false);
    }
  }
};
</script>
<style lang="less" scoped>
.letter-list {
  display: flex;
  height: 150px;
  padding: 0 20px;
  justify-content: space-between;
  align-items: center;
  background: #fff;
}
.child-img,
.child-icon-default {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.child-icon-default {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  color: #fff;
  background: #4196ff;
}
.child-content {
  margin-left: 20px;
  .child-name {
    font-size: 28px;
    margin-bottom: 10px;
  }
  .child-class {
    font-size: 24px;
    color: #666;
    margin-bottom: 6px;
  }
  .child-school {
    font-size: 24px;
    color: #999999;
  }
}
</style>
